import * as React from "react";
import styled from "styled-components";
import { OriginThemeProvider } from "@origin-digital/ods-core";
import { Footer } from "../Footer";
import { CrisisBanner } from "../Banner/CrisisBanner";
import { SacVersionToggle } from "../SacVersionToggle";

const ContentWrapper = styled.div`
  flex: 1 0 auto;
  ${({ background }: { background: "gray" | "white" | undefined }) => {
    if (background === "gray") return `background-color: rgb(241, 241, 241);`;
    if (background === "white") return `background-color: white;`;
    return "";
  }};
`;

const FooterWrapper = styled.div`
  flex-shrink: 0;
`;

const App = ({
  nav,
  footer,
  actionBar,
  title,
  background,
  children,
  showHeader = true,
  showFooter = true,
  authenticated = false,
  initSAC = false,
  liveChat = undefined
}) => {
  return (
    <>
      <OriginThemeProvider>
        <ContentWrapper data-id="tal-content-wrapper" background={background}>
          <CrisisBanner />
          <SacVersionToggle
            initSAC={initSAC}
            liveChat={liveChat}
            showHeader={showHeader}
            authenticated={authenticated}
            nav={nav}
            actionBar={actionBar}
            title={title}
          />
          <div id="oetal-application-root">{children ? children : null}</div>
        </ContentWrapper>
        {showFooter ? (
          <FooterWrapper>
            <Footer {...footer} />
          </FooterWrapper>
        ) : null}
      </OriginThemeProvider>
    </>
  );
};

const Component = App;

export { Component as App };
